import React from 'react';

import { $config } from '@client/core/atoms/config';

export const ShortStatus = () => {
  const config = $config.get();

  const configItems = [
    { label: 'pageType', value: config?.pageType },
    { label: 'deviceType', value: config?.deviceType },
    { label: 'brand', value: config?.brand },
    { label: 'vertical', value: `${config?.vertical} ${config?.subvertical}` },
    { label: 'consent', value: config?.consent },
    {
      label: 'Adservers',
      value: Object.keys(config?.adServer || {})
        .map((key) => key.toUpperCase())
        .join(', ')
    }
  ];

  return (
    <div className="grid grid-cols-3 gap-24 p-24">
      {configItems.map((item, index) => (
        <div
          key={index}
          className="flex flex-col gap-4"
          style={{ textAlign: 'center' }}
        >
          <small className="text-xs s-text-subtle">{item.label}</small>
          <b className="text-m">{item.value}</b>
        </div>
      ))}
    </div>
  );
};
